import {Model} from '@vuex-orm/core'
import Room from '@models/building/Room'
import RoomtypesHasOperationmodesHasAirvolume from '@models/helpers/RoomtypesHasOperationmodesHasAirvolume'

export default class Roomairvolume extends Model {
  static entity = 'roomairvolumes'

  static fields() {
    return {
      id: this.uid(),
      roomId: this.attr(null),

      fZu: this.number(null).nullable(),
      fZuKorr: this.number(null).nullable(),
      resetFZu: this.boolean(false),
      resetFZuKorr: this.boolean(false),

      airvolume: this.number(null),
      
      rl: this.number(null),
      il: this.number(null),
      fl: this.number(null),
      infiltrationAir: this.number(null),
      ald: this.number(null),
      uld: this.number(null),
      doorLeaf: this.number(null),
      fAWrg: this.number(null),
      operationmode: this.number(null),
      operationmodeAirvolume: this.number(null),

      nlZu: this.number(null).nullable(),
      nlAb: this.number(null).nullable(),

      isDefault: this.boolean(false)
    }
  }

  resetOverflowRoom() {
    this.airvolume = 0
    this.rl = 0
    this.il = 0
    this.fl = 0
    this.infiltrationAir = 0
    this.ald = 0
    this.uld = 0
  }

  getDefaultFzu() {
    var room = this.getRoom();
    var roomtype = room.getRoomtype();
    return +parseFloat(roomtype.f_zu).toFixed(1);
  }

  getDefaultFzuDelta() {
    var room = this.getRoom();
    var roomtype = room.getRoomtype();
    return +parseFloat(roomtype.f_zu_max_delta).toFixed(1);
  }

  setFZu() {
    var room = this.getRoom();
    var roomtype = room.getRoomtype();

    //if(room.airType !=  2 || room.ventilationMeasure == 2) {
    if (room.airType != 2) {
      this.fZu = null;
      this.fZuKorr = null;
      return;
    }
    if (this.fZu == null || this.fZu <= 0 || this.resetFZu === true) {
      this.fZu = +parseFloat(roomtype.f_zu).toFixed(1);
      this.fZuKorr = +parseFloat(roomtype.f_zu).toFixed(1);
      this.resetFZu = false;
    }
    if (this.fZuKorr == null || this.fZuKorr <= 0 || this.resetFZuKorr === true) {
      this.fZuKorr = this.fZu;
      this.resetFZuKorr = false;
    }
  }

  getRoom() {
    return Room.find(this.roomId);
  }


  getOperationmodeAirvolume() {
    return RoomtypesHasOperationmodesHasAirvolume.find(this.operationmodeAirvolume)
  }
}
